import { render, staticRenderFns } from "./UploadImgGp.vue?vue&type=template&id=2bbbb06e&scoped=true&"
import script from "./UploadImgGp.vue?vue&type=script&lang=js&"
export * from "./UploadImgGp.vue?vue&type=script&lang=js&"
import style0 from "./UploadImgGp.vue?vue&type=style&index=0&id=2bbbb06e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbbb06e",
  null
  
)

export default component.exports